import { FlexBox } from "components/Common/FlexBox"
import { ConfirmBody, ConfirmTitle, IconWrapper, StyledModal } from "./styled"
import Button from "components/Buttons/Button"

import React from "react"

const InfoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <g clipPath="url(#clip0_40002618_30020)">
      <circle cx="12.5" cy="12" r="9" stroke="#0DA3BA" strokeWidth="2" />
      <rect x="11.5" y="11" width="2" height="6" rx="1" fill="#0DA3BA" />
      <circle cx="12.5" cy="8" r="1" fill="#0DA3BA" />
    </g>
    <defs>
      <clipPath id="clip0_40002618_30020">
        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
)

const AppOutdatePopConfirm = () => {
  return (
    <StyledModal
      style={
        {
          "--app-max-width": "450px",
          "--horizontal-margin": "48px",
          "--max-width":
            "calc(min(100vw,var(--app-max-width)) - var(--horizontal-margin))",
          "--min-width":
            "calc(min(100vw,var(--app-max-width)) - var(--horizontal-margin))",
        } as React.CSSProperties
      }
      visible={true}
      content={
        <FlexBox $direction="column" $gap={16} style={{ width: "100%" }}>
          <FlexBox $direction="column" $gap={4}>
            <FlexBox $justify="center">
              <IconWrapper $type="info">
                <InfoIcon />
              </IconWrapper>
            </FlexBox>
            <ConfirmTitle $type={"info"}>New version available!</ConfirmTitle>

            <ConfirmBody>
              The Food Journal has been updated. Reload now to continue with the
              latest version.
            </ConfirmBody>
          </FlexBox>

          <FlexBox $gap={16} $justify="center">
            <Button
              style={{ width: "50%" }}
              $type={"info"}
              $size="small"
              onClick={() => window.location.reload()}
            >
              Reload
            </Button>
          </FlexBox>
        </FlexBox>
      }
    ></StyledModal>
  )
}

export default AppOutdatePopConfirm
